import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IdleUserService } from '../services';
import { SetLastActivity } from '../services/storage-data.utility';

@Injectable()
export class LastActivityInterceptor implements HttpInterceptor {
  /**
   * Injects the idle user service.
   */
  idleUserService = inject(IdleUserService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const now = new Date();

    SetLastActivity(now);
    this.idleUserService.reset();

    return next.handle(request);
  }
}
